import {
  MDBBtn, MDBContainer,
  MDBInput,
  MDBInputGroup,
  MDBModal,
  MDBModalBody,
  MDBModalContent,
  MDBModalDialog,
  MDBModalFooter,
  MDBModalHeader,
  MDBModalTitle
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { getGlobalLocationList, loginUser } from "../apiclients/streamsapi_bridge.js";
import NightMode from "../components/NightMode/BlackTheme";
import { getStreamsProductName } from "../apiclients/CommonUtils.js";

const LoginNext = () => {
  const passRef = useRef();
  const [basicModal, setBasicModal] = useState(false);

  const toggleOpen = () => setBasicModal(!basicModal);
  const [basicModal1, setBasicModal1] = useState(false);

  const toggleOpen1 = () => setBasicModal1(!basicModal1);

  const [selectedRegion, setSelectedRegion] = useState("IN");
  const { t, i18n } = useTranslation();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [passwordVisible, setPasswordVisible] = useState(false);
  const streamsProductName = getStreamsProductName();
  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  function setUserSession(userInfo) {
    sessionStorage.setItem("admin_session", JSON.stringify(userInfo));
    sessionStorage.setItem("token", userInfo.token);
    sessionStorage.setItem("refreshtoken", userInfo.refreshtoken);
  }

  useEffect(() => {
    passRef.current.focus();
  }, [navigate]);

  useEffect(() => {
    setError("");
  }, [password]);

  const submitHandler = async (e, credentials) => {
    if (e) e.preventDefault();
    let reqInfo = {};
    if (credentials) {
      console.log(credentials);
      reqInfo = await loginUser(credentials);
    } else {
      reqInfo = await loginUser({
        pswdcheck: { username: username, password: password },
      });
    }
    let respInfo = await reqInfo.json();

    console.log(respInfo);
    if (reqInfo.status == 200 && respInfo.status == "success") {
      try {
        setUserSession(respInfo);
        await getGlobalLocation();
        navigate("/home");
      } catch (e) {
        setError("Invalid email or password");
        console.log("Error::::::::::::" + e);
      }
    } else {
      setError("Invalid email or password");
    }
    // setUserSession({ status: "success", sitename: "saasone", siteid: "2930" });
    // navigate("/home");
  };



  async function fetchData() {
    let validSession = false;
    try {
      if (
        sessionStorage.getItem("admin_session") &&
        JSON.parse(sessionStorage.getItem("admin_session")).sitename ==
        localStorage.getItem("admin_user")
      ) {
        validSession = true;
      }
    } catch (e) {
      console.log("errore ::::::::::::::: " + e);
    }
    if (validSession) {
      navigate("/home");
    } else {
      if (localStorage.getItem("admin_user")) {
        console.log(localStorage.getItem("admin_user"));
        setUsername(localStorage.getItem("admin_user"));
      }
    }
  }
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <div className="d-none" >
        <NightMode />
      </div>
      <div className="d-flex loginBg">
        <div className="d-flex  align-items-center w-100 vh-100">
          <MDBContainer className="my-5 gradient-form">
            <div className="box-shadow bgwhite w-40 m-auto">
              <div col="6" className="px-0 pr-5 dnone">
                <div className="d-flex flex-column  justify-content-center gradient-custom-2 h-100 mb-4">
                  <div className="text-white px-3 py-4 p-md-5 mx-md-4">
                    <i
                      className="mb-4 logo"
                    ></i>
                    <h3 className="mb-4">{t("loginTitle")}</h3>
                    <h5 className="mb-4">{t("loginHead", { "PRODUCT_NAME" : streamsProductName })}:</h5>
                    <p className="small mb-0">
                      <ul className="disclist">
                        <li className="ListGroupItem white py-1 bg-transparent">
                          {t("loginlisttxt1")}
                        </li>
                        <li className="ListGroupItem white py-1 bg-transparent">
                          {t("loginlisttxt2")}
                        </li>
                        <li className="ListGroupItem white py-1 bg-transparent">
                          {t("loginlisttxt3")}
                        </li>
                        <li className="ListGroupItem white py-1 bg-transparent">
                          {t("loginlisttxt4")}
                        </li>
                      </ul>
                      <i className="fas fa-phone me-2"></i> {t("reachUs")}
                    </p>
                  </div>
                </div>
              </div>
              <div col="6" className="px-0">
                <form
                  action="#"
                  onSubmit={(e) => submitHandler(e)}
                  target="_blank"
                  className="w-20vw"
                >
                  <div className="d-flex flex-column p-3">
                    <div className="px-3 py-4 py-md-5 my-4 p-md-4 mx-md-4 text-center">
                      <i
                        className="mb-4 logo"
                      ></i>
                      <h5 className="mb-4 pb-1 fw-400 text-left">
                        {t("Hi")} <strong className="fw-bold fs-4">{username}</strong>, {t("plsverify")} <br /><a href="/login" className="text-primary">{t('notyou')}?</a>

                      </h5>
                      <div style={{ color: "red" }}>{error}</div>

                      <MDBInputGroup className='mb-4' noBorder textAfter={
                        <i onClick={togglePasswordVisibility}
                          className={`fas cursor-pointer clearicon ${passwordVisible ? 'fa-eye' : 'fa-eye-slash'} trailing`}></i>
                        // <MDBIcon far icon="eye" />
                      }>
                        <input className='form-control' wrapper
                          ref={passRef}
                          label={t("password")}
                          id="form2"
                          type={passwordVisible ? 'text' : 'password'}
                          onChange={(e) => setPassword(e.target.value)}
                          required />
                      </MDBInputGroup>

                      <div className="d-flex justify-content-between pt-1 mb-3 align-items-center">
                        <a onClick={toggleOpen1}>{t("forgotpwd")}?</a>
                        <MDBBtn
                          type="submit"
                          className="w-30 gradient-custom-2 p-2"
                        >
                          {t("Login")}
                        </MDBBtn>
                      </div>
                      <div className="text-left">
                        <span><input type="checkbox" className="me-2" />{t("keepsignin")}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div className="text-center">
              <p className="small fs-6 my-4">
                {t("copyrighttxt")}
                <a className="fs-6" onClick={toggleOpen}>
                  {t("privacypolicy")}
                </a>
              </p>
            </div>
          </MDBContainer >
        </div >
      </div >
      <MDBModal open={basicModal} onClose={() => setBasicModal(false)} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Privacy Policy</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className="text-start privacycontent">
              <div>
                <b>PanTerra</b> is committed to protecting your privacy. To better protect your privacy, we provide this notice explaining our online information practices and the choices you can make about the way your information is collected and used.
                <ul>
                  <li>
                    <b>The Information We Collect</b>
                    When you visit our site, we may collect personally identifiable information, including name address and email address. We also may collect certain non-personally identifiable information when you visit many of our Web pages, such as the type of browser you are using (e.g., Netscape, Internet Explorer), the type of operating system you are using, (e.g., Windows XP or Mac OSX) and the domain name of your Internet service provider (e.g., America Online, Earthlink).
                  </li>
                  <li>
                    <b>How We Use the Information</b> We use the information you provide about yourself to respond to your inquiries about our products and services, to send you news and updates about our offerings to provide you with opportunities to purchase other products or services that we believe may be of interest to you.

                    We will disclose personally identifiable information in response to legal process or when we believe in good faith that the law requires it.
                  </li>
                  <li>
                    <b>
                      Cookies
                    </b>We use cookies to enhance your experience with our site. Cookies are text files we place in your computers browser to store your preferences. We do not use our cookies to determine any personally identifiable information about you.

                    We use cookies to understand site usage and to improve the content and offerings on our site. For example, we may use cookies to personalize your experience at our Web page (e.g., to recognize you by name when you return to our site). We also may use cookies to offer you products or services.
                  </li>

                </ul>
              </div>
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={toggleOpen}>
                Close
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>

      <MDBModal open={basicModal1} onClose={() => setBasicModal1(false)} tabIndex='-1'>
        <MDBModalDialog>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Forgot Password</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleOpen1}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody className="text-start privacycontent">
              <div className="form-group">
                <label>
                  <strong>
                    User Name / Verified Email Id:
                  </strong>
                </label>
                <MDBInput id="typeEmail" type="email" />
                <p className="my-3"><strong>Note:</strong> Please enter a verified email ID/username to receive an email with a link to finish resetting the password.</p>
              </div>
            </MDBModalBody>

            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={toggleOpen1}>
                Close
              </MDBBtn>
              <MDBBtn color='primary' onClick={toggleOpen1}>
                Send
              </MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
};
export async function getGlobalLocation() {
  try {

    sessionStorage.setItem("current_link", "home");
    const adminSession = sessionStorage.getItem("admin_session");
    const siteid = JSON.parse(adminSession).siteid;
    // const loggedinUser = JSON.parse(adminSession).logined_user;
    let response;
    // if (loggedinUser.indexOf("@") === -1) {
    const extracondition = `?module_type=1`;
    response = await getGlobalLocationList(siteid, extracondition);
    // } else {
    //   response = await getGlobalLocationForUser(siteid, loggedinUser);
    // }

    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    let rawData = await response.json();
    console.log("Global location ::::::::: " + JSON.stringify(rawData));
    if (!rawData) {
      window.alert(`info with id  not found`);
      // navigate("/");
    }
    const globalLoc = rawData?.result ?? [];
    const transformedLocationsList = (globalLoc || []).map(locations => ({ text: locations.entity_name, value: locations.entity_id }));
    const initialSelectedLoc = globalLoc.length > 0 ?
      globalLoc.filter(item => item.selected).map(item => item.entity_id) :
      [];
    console.log("global location data :::: " + JSON.stringify(transformedLocationsList));
    console.log("global location selected :::: " + JSON.stringify(initialSelectedLoc));
    sessionStorage.setItem("global_location_changed", true);
    sessionStorage.setItem("global_location", JSON.stringify(transformedLocationsList));
    sessionStorage.setItem("global_select_location", JSON.stringify(initialSelectedLoc));
  } catch (error) {

  }

}

export default LoginNext;
